import { useQuery } from "@tanstack/react-query";

export interface PlatformBranding {
  id: number;
  appName: string;
  lightLogoUrl: string | null;
  darkLogoUrl: string | null;
  faviconUrl: string | null;
  loginTagline: string;
  loginHeroSubtitle: string;
  emailSenderName: string;
  emailSenderAddress: string;
  hideSidebarAppName: boolean;
  hideSidebarTagline: boolean;
  hideLoginAppName: boolean;
  hideLoginTagline: boolean;
}

const DEFAULTS: PlatformBranding = {
  id: 1,
  appName: "CallKarma.ai",
  lightLogoUrl: null,
  darkLogoUrl: null,
  faviconUrl: null,
  loginTagline: "Contact Center Platform",
  loginHeroSubtitle: "Manage calls, queues, and agents all in one place",
  emailSenderName: "CallKarma.ai",
  emailSenderAddress: "alerts@callkarma.ai",
  hideSidebarAppName: false,
  hideSidebarTagline: false,
  hideLoginAppName: false,
  hideLoginTagline: false,
};

const LS_KEY = "platform_branding_v1";

function readCache(): PlatformBranding | undefined {
  try {
    const raw = localStorage.getItem(LS_KEY);
    return raw ? (JSON.parse(raw) as PlatformBranding) : undefined;
  } catch {
    return undefined;
  }
}

function writeCache(data: PlatformBranding) {
  try {
    localStorage.setItem(LS_KEY, JSON.stringify(data));
  } catch {}
}

export function usePlatformBranding(): PlatformBranding {
  const { data, isPlaceholderData } = useQuery<PlatformBranding>({
    queryKey: ["/api/platform/white-label"],
    staleTime: 5 * 60 * 1000,
    retry: false,
    placeholderData: () => readCache() ?? DEFAULTS,
  });

  // Write real API data to cache synchronously — no extra hook needed
  if (data && !isPlaceholderData) writeCache(data);

  return data ?? DEFAULTS;
}
